export default __webpack_public_path__ + "static/media/favoriteyellow.46820ea4.svg";